import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Tags Post List Saga ***************************
export function* fetchTagsPostListSaga(action) {
  // console.log('action: ', action);
  try {
    // console.log('Here');
    yield put(Creators.fetchTagsPostListStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield `${apiEndpoints.tagsPostList}/${action.tagName}/10`;
    } else {
      url = yield `${apiEndpoints.tagsPostList}/${action.tagName}/10/page/${
        action.pageNumber
      }`;
    }
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const tagsPostList = [];
    if (res.data.success === 1) {
      for (let key in res.data.tagPosts) {
        tagsPostList.push({
          id: key,
          ...res.data.tagPosts[key]
        });
      }
    }
    // console.log('tagsPostList: ', tagsPostList);
    yield put(Creators.fetchTagsPostListSuccess(tagsPostList));
  } catch (err) {
    yield put(Creators.fetchTagsPostListFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Increase Post Count Saga ***************************
export function* increasePostCountSaga(action) {
  try {
    const url = yield `${apiEndpoints.increasePostCount}/${action.postId}`;
    const res = yield axios.post(url);
    // console.log('res: ', res);
    if (res.data.success === 1) {
      return;
    }
  } catch (err) {
    console.log('Error came while increasing post count');
    return;
  }
}
// ______________________________________________________________________________
